// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
// import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
// import { H } from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
// import actions from "model/actions";
import selectors from "model/selectors";
import queryFactory, { client } from "model/gql/queries";
import ClientInfoFull from "components/emission/ClientInfoFull";
// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./ClientInfo.m.scss";

const ClientData = queryFactory(client);
@withRouter
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      currentClient: selectors.clients.currentClient$$(state),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {}
)
@themr("ClientInfo", styles)
export default class ClientInfo extends Component {
  static propTypes = {
    theme: PropTypes.object,
    currentClient: PropTypes.object,
  };

  render() {
    const { theme, currentClient } = this.props;

    return (
      <div className={classnames(theme.wrapper)}>
        {currentClient ? (
          <ClientData
            skip={!currentClient}
            id={currentClient.remoteId}
            type={currentClient.type}
          >
            {({ data, loaded }) => {
              switch (currentClient.type) {
                case "PERSON": {
                  return data && data.clients && data.clients[0] ? (
                    <ClientInfoFull client={data.clients[0]} type={"PERSON"} />
                  ) : null;
                }
                case "COMPANY": {
                  return data && data.companies && data.companies[0] ? (
                    <ClientInfoFull
                      client={data.companies[0]}
                      type={"COMPANY"}
                    />
                  ) : null;
                }
                default: {
                  return null;
                }
              }
            }}
          </ClientData>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/ClientInfo/ClientInfo.js